import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HTMLSiteAdmin from "./HTMLSiteAdmin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RedirectToSite />} />
          <Route path="/admin" element={<HTMLSiteAdmin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

function RedirectToSite() {
  useEffect(() => {
    window.location.href = '/site.html';
  }, []);
  
  return <div>Redirecting...</div>;
}

export default App;